export default __webpack_public_path__ + "static/detailImg2-b37080929a1e0b1516a4383e1b7b7a6c.webp";